import IframeActivity from "./IframeActivity";

export default function ObservationSkills2() {
    return (
        <IframeActivity
            src="/activities/observation-skills-2/index.html"
            title="What Did You Miss Again?"
        />
    );
}